import Users from '@/fixtures/users'
import apiService from '@/services/apiService'

const Conseillers = {
  getConseillers () {
    return new Promise((resolve, reject) => {
      apiService.get('api/advisors')
      .then(result => {
        if (result.data && result.data.advisors) {
          // console.log('Advisors info: ', result.data);
          resolve(result.data.advisors)
        } else {
          reject()
        }
      }).catch(error => reject(error))
    })
  },
  getConseillerById (conseillerId) {
		return new Promise((resolve, reject) => {
      apiService.get(`api/advisor-details/${conseillerId}`)
      .then(result => {
        if (result.data) {
          // console.log('Advisors info: ', result.data);
          resolve(result.data)
        } else {
          reject()
        }
      }).catch(error => reject(error))
    })
  },
  editConseiller (conseiller) {
    return new Promise((resolve, reject) => {
      window.setTimeout(() => {
        Users.forEach((user, index) => {
          if (conseiller.id === user.id) {
            Users[index] = {...conseiller}
          }
        });
        resolve(conseiller)
      }, 500)
    })
  },
  addConseiller (conseiller) {
		return new Promise((resolve, reject) => {
      apiService.post('api/advisors', conseiller)
      .then(result => {
        if (result.data && result.data.user) {
          resolve(result.data.user)
        } else {
          reject()
        }
      })
      .catch(error => reject(error))
    })
  }
}

export default Conseillers



// WEBPACK FOOTER //
// ./src/services/api/conseillers.js